import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const usersApi = createAsyncThunk("users", async ({ name = "", startDate = "", endDate = "" }) => {
  const params = {};

  // Add name to the query if provided
  if (name) {
    params.name = name;
  }

  // Add date range to the query if provided
  if (startDate) {
    params.startDate = startDate;
  }
  if (endDate) {
    params.endDate = endDate;
  }

  const response = await axiosInstance.get("/user_details", {
    params, // Pass the parameters to the API request
  });
  return response.data;
});

const usersSlice = createSlice({
  name: "users",
  initialState: {
    users: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(usersApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(usersApi.fulfilled, (state, action) => {
        state.users = action.payload;
        state.loading = false;
      })
      .addCase(usersApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default usersSlice.reducer;
